import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserLoginHandlerService {

  private subject$ = new Subject<any>();

  userLogin() {
    this.subject$.next();
  }

  getObservable(): Subject<any> {
    return this.subject$;
  }
}
